import { Injectable } from '@angular/core';

import { DataManager } from "techlify-ng";

/**
 * Service that provides Health Issue Data
 * 
 * @author Floyd Kissoon
 * @since 20180512
 */
@Injectable()
export class HealthIssueDataService
{

    private data: any;

    constructor(private dataManager: DataManager)
    {

    }

    getHealthIssues()
    {
        var promise;
        if(undefined !== this.data)
        {
            promise = new Promise((resolve, reject) =>
            {
                resolve(this.data);
            });

            return promise;
        }

        promise = this.dataManager.GET("api/health/issue", { sort_by: "name|ASC" });

        promise.then(
            res =>
            {
                this.data = res;
            }
        );

        return promise;
    }

}